import {Sortable} from "./sortable.js";
import {handleFetchError, YummyServerError} from "../../helpers/functions.js";
import {ServerApi} from "../../api.js";
import {IOneAnimeJson} from "../../../../../nodeserver/structs/database";
import {types} from "../../config.js";
import JSX from "../../helpers/react.js";


function onLoad(){
    const $editForm = $('.edit-form');
    Sortable.create(
        $editForm.find('.enable-reorder')[0]!, {
            onEnd (e){
                console.log("Updated!")
                for(const element of Array.from($editForm.find('.item-sorting'))) {
                    $(element).find('input[name="viewing_order_item_index[]"]')
                        .val($(element).index());
                }
            },
            ghostClass: "transparent",

        });

}
$('html').on('click', '.add-viewing-order-button', function (e){
    if($(e.target).closest('.input-field')[0])return;
    $(this).find('.input-field').toggleClass('hidden');
})
    .on('click', '.add-viewing-order-button .add-btn', function(){
        const $input = $(this).prev() as JQuery<HTMLInputElement>;
        const text = $input.val()! as string;
        $input.val('');
        let url = text.split('?')[0];
        const path = url.split(/[\/|\\]/).filter(e=>e);
        addAnimeViewingOrder(path[path.length-1]).catch(handleFetchError)
    });

async function addAnimeViewingOrder(path: string){
    const anime = await ServerApi.anime.get(path);
    createViewingOrderAnime(anime);
}

function createViewingOrderAnime(anime: IOneAnimeJson){
    const $container = $('#viewing-order-content .view-list ol');
    if($container.find(`input[name="viewing_order_item_id[]"][value=${anime.anime_id}]`)[0])
        throw new YummyServerError('Такое аниме уже есть в порядке просмотра!');

    const $element = $(
        <li className="item-sorting">
        <a href={"/catalog/item/"+anime.anime_url} className="current">{escapeHtml(anime.title)}</a>&nbsp;-&nbsp;{anime.type.shortname},&nbsp;
            <input type="text" className="no-fill bordered" name="viewing_order_title[]" value="" placeholder="дополнение/продолжение/адаптация манги"/> ,&nbsp;{!!anime.year && anime.year}
            <input hidden type="hidden" name="viewing_order_item_id[]" value={anime.anime_id} />
            <div className="delete-button">
                <i className="far fa-trash" />
            </div>
    </li>
    );
    $container.append($element);
}
document.addEventListener('oneditformload', onLoad);
